// extracted by mini-css-extract-plugin
export var columnList = "_gt-0";